module.exports = __webpack_public_path__ + "static/media/scallion.34cf8086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/scallion.jpg
// module id = 132
// module chunks = 0